import React from "react";
import { Col, Form, Modal, Row, Select } from "antd";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { dspxGetWorkerChildrens } from "../../../helpers/dspx-utils";
import { EditDocumentIcon } from "../../../resource/icons";

import actions from "../store/actions/edit-document.actions";

const EditResponsibleWorkerModal = ({
	workersList,
	validateFields,
	getFieldDecorator,
	visible,
	onCancel,
	responsibleWorker,
	prepareDataAndResetFields,
}) => {
	const dispatch = useDispatch();

	const subject = "Ответственный";
	const subject_err = "ответственного";

	const onResponsibleWorkerChanged = useCallback(() => {
		validateFields((err, values) => {
			if (err) return;
			const v = prepareDataAndResetFields(values);
			const worker = workersList.find((worker) => {
				return +worker.id === +v.newResponsibleWorkerId;
			});
			dispatch(actions.updateResponsibleWorker(v.id, worker));
			dispatch(actions.closeModal());
		});
	}, [validateFields]);
	return (
		<Modal
			style={{ minWidth: 400 }}
			width={500}
			visible={visible}
			title={
				<div style={{ display: "flex", alignItems: "center" }}>
					<EditDocumentIcon
						style={{
							height: 40,
							verticalAlign: "middle",
							marginRight: 10,
						}}
					/>
					<div>
						{responsibleWorker
							? `Замена ответственного ${responsibleWorker.fullName}`
							: "Добавить ответственного"}
					</div>
				</div>
			}
			okText="Изменить"
			onCancel={onCancel}
			onOk={onResponsibleWorkerChanged}
		>
			<Form layout="vertical">
				<Row gutter={8}>
					<Col span={24}>
						<Form.Item label={subject}>
							{getFieldDecorator("newResponsibleWorkerId", {
								initialValue: responsibleWorker && responsibleWorker.id + "",
								rules: [
									{
										required: false,
										message: "Пожалуйста, укажите " + subject_err,
									},
								],
							})(
								<Select
									showSearch
									placeholder="ответсвенный"
									notFoundContent="нет данных"
									optionLabelProp="label"
									optionFilterProp="searchtext"
								>
									{dspxGetWorkerChildrens(workersList)}
								</Select>
							)}
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default EditResponsibleWorkerModal;
